var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gf-collapse"},[_c('div',{staticClass:"gf-collapse__toggle",class:[{ '--hide': _vm.isHidedToggle }, _vm.toggleClass],on:{"click":_vm.click}},[_vm._t("toggle")],2),_c('div',{staticClass:"gf-collapse__collapse",class:{ '--show': _vm.isOpen }},[_vm._t("collapse")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }